import Progress from './progress';
export default Progress;


//////////////////
// WEBPACK FOOTER
// /Users/jim/Documents/GitHub/chenshuai/ant-design-pro-site/scaffold/node_modules/antd/es/progress/index.js
// module id = null
// module chunks = 